
import { motion} from 'framer-motion';
import {  useState, useEffect } from 'react';

export default function TestimonialsSection() {

  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  const testimonials = [
    {
      id: 1,
      name: 'Sarah Chen',
      position: 'CEO',
      company: 'TechVision Inc.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20business%20woman%20CEO%20in%20modern%20office%20setting%2C%20confident%20executive%20portrait%2C%20contemporary%20business%20attire%2C%20sophisticated%20professional%20headshot%2C%20corporate%20leadership%2C%20premium%20office%20environment&width=80&height=80&seq=testimonial-sarah&orientation=squarish',
      rating: 5,
      content: "The transformation of our headquarters exceeded every expectation. The attention to detail and quality of craftsmanship is simply outstanding.",
    },
    {
      id: 2,
      name: 'Michael Rodriguez',
      position: 'Operations Director',
      company: 'Global Dynamics',
      image: 'https://readdy.ai/api/search-image?query=Professional%20business%20man%20operations%20director%20in%20corporate%20office%2C%20executive%20portrait%2C%20business%20suit%2C%20confident%20professional%20headshot%2C%20modern%20workplace%20setting%2C%20corporate%20leadership%20style&width=80&height=80&seq=testimonial-michael&orientation=squarish',
      rating: 5,
      content: "Working with this team was a game-changer for our company culture. The new workspace has dramatically improved collaboration and productivity.",
    },
    {
      id: 3,
      name: 'Emily Watson',
      position: 'HR Director',
      company: 'Innovation Labs',
      image: 'https://readdy.ai/api/search-image?query=Professional%20business%20woman%20HR%20director%20in%20modern%20office%2C%20friendly%20executive%20portrait%2C%20professional%20attire%2C%20warm%20corporate%20headshot%2C%20contemporary%20workplace%2C%20human%20resources%20leadership&width=80&height=80&seq=testimonial-emily&orientation=squarish',
      rating: 5,
      content: "From concept to completion, every aspect was handled with professionalism. Our employees love coming to work in this beautiful environment.",
    },
    {
      id: 4,
      name: 'David Park',
      position: 'Founder',
      company: 'StartupHub',
      image: 'https://readdy.ai/api/search-image?query=Young%20professional%20startup%20founder%20in%20modern%20office%2C%20entrepreneur%20portrait%2C%20casual%20business%20attire%2C%20innovative%20leader%20headshot%2C%20tech%20startup%20environment%2C%20creative%20workspace%20setting&width=80&height=80&seq=testimonial-david&orientation=squarish',
      rating: 5,
      content: "The design perfectly captures our startup culture while maintaining the professionalism we need for client meetings. Absolutely perfect!",
    },
    {
      id: 5,
      name: 'Lisa Thompson',
      position: 'Creative Director',
      company: 'Design Studio Pro',
      image: 'https://readdy.ai/api/search-image?query=Creative%20professional%20woman%20director%20in%20artistic%20office%20space%2C%20designer%20portrait%2C%20creative%20professional%20attire%2C%20artistic%20workspace%20headshot%2C%20design%20studio%20environment%2C%20creative%20leadership&width=80&height=80&seq=testimonial-lisa&orientation=squarish',
      rating: 5,
      content: "They understood our creative vision and brought it to life beyond our wildest dreams. The space truly inspires our team every day.",
    },
  ];

  const stats = [
    {
      value: '500+',
      label: 'Projects Completed',
      description: 'Successful transformations'
    },
    {
      value: '98%',
      label: 'Client Satisfaction',
      description: 'Happy customers'
    },
    {
      value: '15+',
      label: 'Years Experience',
      description: 'Industry expertise'
    },
    {
      value: '50+',
      label: 'Team Members',
      description: 'Design professionals'
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [testimonials.length]);

  const nextTestimonial = () => {
    setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentTestimonial((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section id="testimonials" className="py-16 relative">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="text-[#d02b37] text-xs uppercase tracking-wider font-medium mb-3 block">
            Client Success Stories
          </span>
          <h2 className="text-2xl md:text-3xl font-bold mb-4 text-white">
            What Our Clients Say
          </h2>
          <p className="text-base text-[#e0e0e0] max-w-2xl mx-auto">
            Don't just take our word for it. Hear from the leaders who have transformed their workspaces and elevated their business success.
          </p>
        </motion.div>

        {/* Main Testimonial Carousel */}
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8 }}
          className="relative max-w-3xl mx-auto mb-12"
        >
          <div className="relative h-80 overflow-hidden rounded-2xl bg-white/5 backdrop-blur-sm border border-white/10 shadow-2xl">
            {testimonials.map((testimonial, index) => (
              <div
                key={testimonial.id}
                className={`absolute inset-0 flex items-center justify-center p-6 transition-all duration-700 ${
                  index === currentTestimonial
                    ? 'opacity-100 transform-none'
                    : 'opacity-0 transform rotateY(-90deg)'
                }`}
              >
                <div className="text-center max-w-2xl">
                  <div className="w-12 h-12 bg-[#d02b37] rounded-full flex items-center justify-center mx-auto mb-6">
                    <i className="ri-double-quotes-l text-white text-lg"></i>
                  </div>
                  
                  <div className="flex justify-center gap-1 mb-4">
                    {[...Array(5)].map((_, i) => (
                      <motion.i
                        key={i}
                        initial={{ opacity: 0, scale: 0 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ delay: i * 0.1 }}
                        className="ri-star-fill text-yellow-400 text-lg"
                      />
                    ))}
                  </div>

                  <motion.p
                    initial={{ opacity: 0, y: 20 }}
                    animate={index === currentTestimonial ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
                    transition={{ duration: 0.6, delay: 0.2 }}
                    className="text-lg md:text-xl text-[#e0e0e0] leading-relaxed mb-6 italic font-light"
                  >
                    "{testimonial.content}"
                  </motion.p>

                  <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={index === currentTestimonial ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
                    transition={{ duration: 0.6, delay: 0.4 }}
                    className="flex items-center justify-center gap-3"
                  >
                    <div className="relative">
                      <img
                        src={testimonial.image}
                        alt={testimonial.name}
                        className="w-12 h-12 rounded-full object-cover border-2 border-[#d02b37]/50"
                      />
                    </div>
                    <div className="text-left">
                      <h4 className="text-white font-bold text-base">{testimonial.name}</h4>
                      <p className="text-[#f0f0f0] text-sm">{testimonial.position}</p>
                      <p className="text-[#d02b37] font-medium text-sm">{testimonial.company}</p>
                    </div>
                  </motion.div>
                </div>
              </div>
            ))}
          </div>

          {/* Navigation Dots */}
          <div className="flex justify-center gap-2 mt-6">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentTestimonial(index)}
                className={`w-2 h-2 rounded-full transition-all duration-300 ${
                  index === currentTestimonial
                    ? 'bg-[#d02b37] scale-125'
                    : 'bg-white/30 hover:bg-white/50'
                }`}
              />
            ))}
          </div>

          {/* Navigation Arrows */}
          <button
            onClick={prevTestimonial}
            className="absolute left-3 top-1/2 transform -translate-y-1/2 w-10 h-10 bg-white/10 hover:bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center transition-all duration-300 group"
          >
            <i className="ri-arrow-left-line text-white text-lg group-hover:scale-110 transition-transform"></i>
          </button>
          <button
            onClick={nextTestimonial}
            className="absolute right-3 top-1/2 transform -translate-y-1/2 w-10 h-10 bg-white/10 hover:bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center transition-all duration-300 group"
          >
            <i className="ri-arrow-right-line text-white text-lg group-hover:scale-110 transition-transform"></i>
          </button>
        </motion.div>

        {/* Stats Grid */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="grid md:grid-cols-4 gap-6"
        >
          {stats.map((stat, index) => (
            <motion.div
              key={stat.label}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="text-center bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-4 hover:bg-white/10 transition-all duration-500 group"
            >
              <div className="text-xl md:text-2xl font-bold text-[#d02b37] mb-1 group-hover:scale-110 transition-transform">
                {stat.value}
              </div>
              <div className="text-[#f0f0f0] font-medium uppercase tracking-wider text-xs">
                {stat.label}
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
